import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { makeStyles } from "@material-ui/core/styles";
import pdf from "../../resources/downloadpdf.png"; // Tell webpack this JS file uses this image
import { Link } from "react-router-dom";
import { ReportTables } from "./ReportTables";
import { TopRelativeVolume } from "./TopRelativeVolume";
import { db } from "../../config/Firebase";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: 500,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  chip: {
    margin: 10,
  },
  head: {
    backgroundColor: "#01579b",
    color: "#FFF",
  },
  headFont: {
    color: "#FFF",
  },
  bullFontColor: {
    color: "red",
  },
  pdf: {
    width: "150px",
  },
  pageH: {
    minHeight: "800px",
  },
});


const Report = () => {
  const [strength, setStrength] = useState(null);
  const [time, setTime] = useState(null);
  const [sum, setSum] = useState(null);
  const [vol, setVol] = useState(null);
  const [note, setNote] = useState(null);
  const [link, setLink] = useState(null);
  const [tableTime, setTableTime] = useState(null);
  const [realatedVol, setRealatedVol] = useState(null);
  const classes = useStyles();
  const { activeUser } = useAuth();

  useEffect(() => {
    db.collection("daily")
      .get()

      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let x;
          if (doc.id === "time") {
            x = doc.data();
            setTime(x);
          }
          if (doc.id === "daily_top_uoa_strength") {
            x = doc.data();
            setStrength(x);
          }
          if (doc.id === "daily_top_uoa_sum") {
            x = doc.data();
            setSum(x);
          }
          if (doc.id === "daily_top_vol") {
            x = doc.data();
            setVol(x);
          }
          if (doc.id === "market_note") {
            x = doc.data();
            setNote(x);
          }
          if (doc.id === "report_link") {
            x = doc.data();
            setLink(x);
          }
          if (doc.id === "table_time") {
            x = doc.data();
            setTableTime(x);
          }
          if (doc.id === "top_related_vol") {
            x = doc.data();
            setRealatedVol(x);
          }
          // console.log(doc.id, " => ", doc.data());
        });
      });
  }, []);

  // useEffect(() => {
  //   let historyData;
  //   if (data !== null) {
  //     data.forEach((doc) => {
  //       if (doc.id === "time") {
  //         historyData = doc;
  //       }
  //     });
  //   }
  //   console.log(historyData);
  // }, [data]);

  return (
    <>
      {realatedVol === null ? (
        <div
          style={{ minHeight: `100vh` }}
          className="d-flex justify-content-center align-items-center"
        >
          <div className="loader"> <CircularProgress /></div>
        </div>
      ) : (
        <div
          className={`pt-5 bg-light-2 ${classes.pageH}`}
          style={{ fontSize: `0.8rem` }}
        >
          {console.log(vol)}
          <section className="pt-5 mb-5 container">
            <div className="container-fluid">
              <h1 className="text-center font-weight-bold mt-5 mb-3">
                {time?.t} Daily Market Report
              </h1>
              <div className="mb-4">
                <p className="text-center font-weight-light h6 text-black-50 mb-4 py-1">
                  Register as a member for free and have access to all
                  historical files and UOA tracker
                </p>
                <div className="footer">
                  <div
                    className="iconsBaby d-flex align-items-baseline position-relative"
                    style={{ height: 150 }}
                  >
                    <Link className="btn btn-call rounded-pill py-3 px-5 mx-auto mt-auto mt-md-0 shadow">
                      <h3 className="mb-0">Get Started</h3>
                    </Link>
                    <Link
                      className="position-absolute"
                      style={{ right: 0 }}
                      to={{ pathname: "http://bit.ly/3nKBim1" }}
                      target="_blank"
                    >
                      <img className={classes.pdf} src={pdf} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="container-fluid">
            <div className="row">
              <div className="col col-xl-7 order-last order-xl-first">
                <ReportTables
                  tableTime={tableTime}
                  sum={sum}
                  strength={strength}
                />
              </div>
              <div className="col-12 col-md-6 col-xl-5">
                <TopRelativeVolume
                  note={note}
                  realatedVol={realatedVol}
                  tableTime={tableTime}
                  vol={vol}
                />
              </div>
              {/* TODO fill link address */}
              {/* <div className="col-12 col-md-6 col-xl-2">
                <HistoricalReports link={link} />
              </div> */}
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default Report;
